import { createAction } from '@wix/communities-blog-client-common';

export const PAGE_OPENED = 'page/PAGE_OPENED';

export const pageOpened = createAction(PAGE_OPENED);
